import React, { Fragment } from 'react';
import { NavLink } from 'react-router-dom';

export default class Navigation
extends React.Component {
	state = {};

	render () {
		const { id, artist } = this.props;
		const { active } = this.state;
		const LinkItem = ({ activeSlug, label, to }) => (
			<NavLink
				className={ active === activeSlug ? 'active' : '' }
				onClick={ () => { this.setState({active: activeSlug}) } }
				exact to={ to }
			>
				{ label }
			</NavLink>
		);

		return (
			<Fragment>
				<div className="grid-x">
					<div className="cell">
						<nav>
							<ul className="margin-left-1 menu horizontal artist-nav">
								<li>
									<LinkItem
										label="Tracks"
										activeSlug="tracks"
										to={ `/artist/${id}/tracks` }
									/>
								</li>
								{artist.albums.length > 0 && (<li>
									<LinkItem
										label="Albums"
										activeSlug="albums"
										to={ `/artist/${id}/albums` }
									/>
								</li>)}
								<li>
									<LinkItem
										label="Biography"
										activeSlug="bio"
										to={ `/artist/${id}/bio` }
									/>
								</li>
							</ul>
						</nav>
					</div>
				</div>

				{/* <div className="grid-x">
					<div className="cell small-4 text-center">
						<div>
							<a href="javascript:void(0)">
								<span className="icon fi-share"></span> Share
							</a>
						</div>
					</div>
				</div> */}
			</Fragment>
		);
	}
}
